export type ConfigureExample = {
  id: string
  prompt: string
  mode: 'vehicle' | 'keywords'
  topic: string
  keywords: string[]
  vehicle: { make: string; model: string; year: string } | null
}

export const CONFIGURE_EXAMPLES: ConfigureExample[] = [
  {
    id: 'peanuts',
    prompt: 'My son is allergic to peanuts',
    mode: 'keywords',
    topic: 'allergies',
    keywords: ['peanuts'],
    vehicle: null,
  },
  {
    id: 'rav4',
    prompt: 'We drive a 2019 Toyota RAV4',
    mode: 'vehicle',
    topic: 'vehicle',
    keywords: [],
    vehicle: { make: 'TOYOTA', model: 'RAV4', year: '2019' },
  },
  {
    id: 'newborn',
    prompt: 'We have a newborn and use a stroller and a crib',
    mode: 'keywords',
    topic: 'children',
    keywords: ['stroller', 'crib'],
    vehicle: null,
  },
  {
    id: 'losartan',
    prompt: 'I take losartan for my blood pressure',
    mode: 'keywords',
    topic: 'drugs',
    keywords: ['losartan'],
    vehicle: null,
  },
  {
    id: 'garage',
    prompt: 'Space heaters and lithium batteries in our garage',
    mode: 'keywords',
    topic: 'consumer',
    keywords: ['space heaters', 'lithium batteries'],
    vehicle: null,
  },
]
